/* eslint-disable */
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {GAME_CONVENTIONS, HISTORY_TABLE_TITLES} from "../../../constants/index.jsx";
import TableHeader from "../../../core/Table/TableHeader/TableHeader.jsx";
import {useTranslation} from "react-i18next";
import {formatTimestamp} from "../../../utils/index.js";
import {
    getHistorySelectedRoomActions,
    setHistorySelectedRoomId,
} from "../../../redux/actions/history/actions.js";
import Button from "../../../core/Button/Button.jsx";
import {cleanUpHistoryRooms, roomEnter} from "../../../redux/actions/rooms/actions.js";
import {selectActiveRoomTab} from "../../../redux/actions/lobby/actions.js";

function HistoryList() {
    const {isMobile, currency} = useSelector((state) => state.user);
    const {t} = useTranslation();
    const {filter, list: roomList, selectedRoomId, selectedRooms} = useSelector((state) => state.history);
    const [rows, setRows] = useState([]);
    let filteredRoomList = roomList.map(item => ({row: item}));
    const flattedConventions = GAME_CONVENTIONS.flat();
    const dispatch = useDispatch();

    const applyFilters = () => {
        for (const key in filter) {
            if (filter[key] && key === "minBet") {
                filteredRoomList = filteredRoomList.filter(item => {
                    return (+item?.row?.table_history_bet[currency]) >= filter.minBet
                })
            }
            if (filter[key] && key === "maxBet") {
                filteredRoomList = filteredRoomList.filter(item => {
                    return (+item?.row?.table_history_bet[currency]) <= filter.maxBet
                })
            }
            if (filter[key] && key === "result") {
                const value = filter.result.value;
                if (value !== 'all') {
                    filteredRoomList = filteredRoomList.filter(item =>
                        item?.row?.table_history_result === value
                    );
                }
            }
            if (filter[key] && key === "till") {
                const value = filter.till.value;
                if (value !== 'all') {
                    filteredRoomList = filteredRoomList.filter(item =>
                        item?.row?.table_history_till === value
                    );
                }
            }
            if (filter[key] && key === "type") {
                const value = filter.type.value;
                if (value !== 'all') {
                    filteredRoomList = filteredRoomList.filter(item => {
                        if (value === 'tournament') {
                            return item?.row?.table_history_tournamentId !== null
                        } else {
                            return item?.row?.table_history_tournamentId === null
                        }
                    });
                }
            }
        }
        setRows(filteredRoomList)
    }

    useEffect(() => {
        applyFilters()
    }, [filter, roomList]);

    const getTitle = (value) => {
        return flattedConventions.find(item => item.value === value)?.label
    }

    const openHistoryRoom = (event, roomId) => {
        event.stopPropagation();
        dispatch(cleanUpHistoryRooms());
        if (selectedRooms?.[selectedRoomId]) {
            dispatch(roomEnter({
                roomId: selectedRoomId,
                isViewRoom: true,
                historyRoomPlayer: true,
                tournamentId: null,
                notifier: false
            }));
            dispatch(selectActiveRoomTab({roomId: selectedRoomId}));
            return;
        }
        dispatch(getHistorySelectedRoomActions({roomId: selectedRoomId}))
        dispatch(selectActiveRoomTab({roomId}));
    }

    const handleHistoryItemClick = (roomId) => {
        dispatch(setHistorySelectedRoomId({roomId}));
    }

    const handleHistoryItemClickMobile = (roomId) => {
        const targetRoomId = selectedRoomId === roomId ? null : roomId;
        dispatch(setHistorySelectedRoomId({roomId: targetRoomId}));
    }
    const renderRow = (cells, key) => {
        return (
            <div key={key + 'desktop-history'} className={`table-body--row hover`}
                 onClick={() => handleHistoryItemClick(cells['table_history_game_id'])}>
                <div className="table-body--cell">{cells['table_history_game_id']}</div>
                <div className="table-body--cell">
                    <i className={`icon-${cells['table_history_type']} table-icon`}/>
                </div>
                <div className="table-body--cell">{cells['table_history_opponent']}</div>
                <div className="table-body--cell">
                    {(cells['table_history_bet']?.[currency])?.toFixed(2)}
                    <span className="currency-small">{' ' + currency}</span>
                </div>
                <div className="table-body--cell">{cells['table_history_till']}</div>
                <div className="table-body--cell">
                    <div className="table-body--cell--icons">
                        {
                            cells?.['table_history_conventions']?.map((item, index) => {
                                return <i
                                    key={`icon-${item}${index}`}
                                    className={`icon-${item} table-icon`}
                                    title={t(`form.${getTitle(item)}`)}
                                />
                            })
                        }
                    </div>
                </div>
                <div className="table-body--cell">{cells['table_history_step_time']} {t('table.s')}</div>
                <div className="table-body--cell">{formatTimestamp(cells['table_history_started'], "full-date")}</div>
            </div>
        )
    }
    const renderRowMobile = (cells, key) => {
        return (
            <div key={key + 'mobile-history'} className="mobile-history-list__wrapper"
                 onClick={() => handleHistoryItemClickMobile(cells['table_history_game_id'])}>
                <div className="mobile-history-list__item">
                    <div className="mobile-history-list__item--col">
                        <i className={`icon-${cells["table_history_type"]}`}/>
                        <span>{cells["table_history_game_id"]}</span>
                    </div>
                    <div className="mobile-history-list__item--col">
                        <span>{formatTimestamp(cells['table_history_started'], "day-month-time")}</span>
                    </div>
                    <div className="mobile-history-list__item--col">
                        <span>{(cells["table_history_bet"]?.[currency])?.toFixed(2)} {currency}</span>
                        <i className="icon-arrow"/>
                    </div>
                </div>
                {selectedRoomId === cells['table_history_game_id'] &&
                    <ul className="mobile-history-list__item--dropdown">
                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.game_id")}</span>
                            {cells["table_history_game_id"]}
                        </li>
                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.bet")}</span>
                            {(cells["table_history_bet"]?.[currency])?.toFixed(2)} {currency}
                        </li>
                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.opponent")}</span>
                            {cells["table_history_opponent"]}
                        </li>
                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.till")}</span>
                            {cells["table_history_till"]}
                        </li>
                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.step_time")}</span>
                            {cells["table_history_step_time"]}{t('history.s')}
                        </li>

                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.score")}</span>
                            {cells["table_history_points"]}
                        </li>
                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.result")}</span>
                            {t(`history.${cells["table_history_result"]}`)}
                        </li>
                        <li className="mobile-history-list__item--dropdown--row">
                            <span>{t("history.type")}</span>
                            <span>
                            {
                                cells["table_history_conventions"]?.map((item, index) => {
                                    return <i
                                        key={`icon-${item}${index}`}
                                        className={`icon-${item} table-icon`}
                                    />
                                })
                            }
                        </span>
                        </li>
                        <li className="mobile-history-list__item--dropdown--row">
                            <Button
                                type="blue"
                                text={t('buttons.view')}
                                onClick={(event) => openHistoryRoom(event, cells['table_history_game_id'])}
                            />
                        </li>
                    </ul>
                }
            </div>
        )
    }

    return <>
        {
            !isMobile
                ?
                <div className="table-wrapper">
                    <div className="table">
                        <TableHeader columns={HISTORY_TABLE_TITLES}/>
                        <div className="table-body">
                            {
                                rows?.map((row, index) => {
                                    return renderRow(row?.row, index)
                                })
                            }
                        </div>
                    </div>
                </div>
                :
                <div className="mobile-history-list">
                    <div className="mobile-history-list__header">
                        <div className="mobile-history-list__title">{t("history.game_id")}</div>
                        <div className="mobile-history-list__title">{t("history.date")}</div>
                        <div className="mobile-history-list__title">{t("history.bet")}</div>
                    </div>

                    <div className="mobile-history-list__body">
                        {
                            rows?.map((row, index) => {
                                return renderRowMobile(row?.row, index)
                            })
                        }
                    </div>
                </div>
        }
    </>

}

export default HistoryList;
